import {authActions} from '../store/auth-actions';
import _u from './utils';

function initInternalAuth({refreshInternalAuthTokenUrl}) {
    authActions.setRefreshInternalAuthTokenUrl(refreshInternalAuthTokenUrl);
    _u.refreshInternalAuthTokenAsync();
}

export {initInternalAuth};
